module.exports = __webpack_public_path__ + "static/dog-leash-walking-18e819a7374e8a68e120234856db1933.jpg";